export const TITLECASE_LOWERCASE_WORDS: string[] = [
  'a',
  'an',
  'and',
  'as',
  'at',
  'but',
  'by',
  'for',
  'in',
  'nor',
  'of',
  'on',
  'or',
  'so',
  'the',
  'to',
  'up',
  'yet',
]

// Rules assessment constants
export const HARD_FAIL_RULE_KEYS = [
  'has_dot_number',
  'multi_currency_bipd_requirement',
  'multi_currency_cargo_requirement',
  'no_active_oos_orders',
  'safer_operating_status_active',
  'safety_rating_satisfactory_or_unrated',
]

export const SOFT_FAIL_RULE_KEYS = [
  'authority_age_requirement',
  'has_mc_number',
  'has_no_published_identity_alerts',
  'has_verified_manually_entered_identifier',
  'has_vin_if_auto_policy_is_scheduled_autos',
  'insight_types_requiring_approval',
  'interstate_carrier_authority_is_active',
  'Is Verified Admin',
  'is_authorized_for_property',
  'triumph_pay_load_indicator_passing',
  'insurance_insurers_requiring_approval',
  'has_no_published_watchdog_identity_alerts',
  'Verified EIN',
]

export const ALWAYS_OVERRIDEABLE_RULE_KEYS = [
  'Does Not Require Additional Docs',
  'BCA',
  'W9',
  'Is Verified Admin',
  'has_vin_if_auto_policy_is_scheduled_autos',
  'Verified EIN',
]

export const TRANSFIX_RULE_KEYS = ALWAYS_OVERRIDEABLE_RULE_KEYS.filter(
  rule => rule !== 'has_vin_if_auto_policy_is_scheduled_autos'
)

export const INCOMPLETE_RULES = ALWAYS_OVERRIDEABLE_RULE_KEYS

export const ALL_RULE_KEYS = [...HARD_FAIL_RULE_KEYS, ...SOFT_FAIL_RULE_KEYS, ...INCOMPLETE_RULES]

export const FAIL_RULES = SOFT_FAIL_RULE_KEYS.filter(rule => !INCOMPLETE_RULES.includes(rule))

export const PASS_RULES = [...INCOMPLETE_RULES, ...FAIL_RULES]
